import { render } from "./TheHeader.vue?vue&type=template&id=4ea04114&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=4ea04114&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ea04114"

export default script